import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { memo } from "react";
import { equals } from "ramda";
import { Select } from "@interdependence-ui";
import { getPeriod, allPeriodTypes, translatePeriod } from "utils/periods";
import { adjustDateParams } from "utils/queryParams";
import { sort } from "utils/sort";
import { extendedSystemStylesProps } from "@mixins";
import { jsx as _jsx } from "react/jsx-runtime";
var styledSystemKeys = ["space", "layout", "flexbox", "border"];
export default /*#__PURE__*/memo(function SelectPeriodType(props) {
  var id = props.id,
    periodType = props.periodType,
    onChange = props.onChange,
    availableTypes = props.availableTypes,
    dateFrom = props.dateFrom,
    dateTo = props.dateTo,
    earliestDataDate = props.earliestDataDate,
    lastDataDate = props.lastDataDate;
  var periodKeys = Object.keys(allPeriodTypes);
  var options = availableTypes.map(function (type) {
    return {
      id: type,
      label: translatePeriod(type)
    };
  });
  var sortedOptions = sort(function (option) {
    return periodKeys.indexOf(option.id.toLowerCase());
  }, options);
  var handleChange = function handleChange(idx) {
    var _sortedOptions$idx, _getPeriod, _getPeriod2;
    var newPeriodType = (_sortedOptions$idx = sortedOptions[idx]) === null || _sortedOptions$idx === void 0 ? void 0 : _sortedOptions$idx.id;
    if (idx === -1 || equals(newPeriodType, periodType)) return;
    var newDateFrom = ((_getPeriod = getPeriod(newPeriodType, dateFrom)) === null || _getPeriod === void 0 ? void 0 : _getPeriod.start) || null;
    var newDateTo = ((_getPeriod2 = getPeriod(newPeriodType, dateTo)) === null || _getPeriod2 === void 0 ? void 0 : _getPeriod2.end) || null;
    var metadata = {
      periodTypes: availableTypes,
      earliestDataDate: earliestDataDate,
      lastDataDate: lastDataDate
    };
    var params = adjustDateParams({
      periodType: newPeriodType,
      dateFrom: newDateFrom,
      dateTo: newDateTo
    }, metadata);
    onChange(params);
  };
  return /*#__PURE__*/_jsx(Select, _objectSpread({
    id: "select-periodtype-".concat(id || ""),
    label: "V\xE4lj period",
    hideLabel: true,
    selectedPrefix: /*#__PURE__*/_jsx("strong", {
      children: "Period:\xA0"
    }),
    _selected: sortedOptions.findIndex(function (option) {
      return equals(option.id.toLowerCase(), periodType === null || periodType === void 0 ? void 0 : periodType.toLowerCase());
    }),
    options: sortedOptions,
    onChange: handleChange
  }, extendedSystemStylesProps(styledSystemKeys, props)), sortedOptions);
}, function (prev, curr) {
  return equals(prev, curr);
});